import React from 'react';
import { renderFunc, sortFields } from '../common';
import Popup from 'semantic-ui-react/dist/commonjs/modules/Popup';
import {
  PersonalContainer,
  PersonalFieldRelationshipContainer,
  GridColumn,
  BankNameContainer
} from '../styled-components';
import pick from 'lodash/pick';
import omit from 'lodash/omit';
import PropTypes from 'prop-types';
import { BANK_NAME_POPUP_CONTENT } from '../../../components/alert-Message/constants';
import { INFO_GREY_ICON } from '@Images';
import { useSelector } from 'react-redux';
import { getFormMeta, getFormSyncErrors } from 'redux-form';

const PersonalScreen = (props) => {
  const allFields = props.personal_fields;
  const topFields = pick(allFields, ['remitter_beneficiary_relationship']);
  const remainingFields = omit(allFields, ['remitter_beneficiary_relationship']);
  const sortedFields = sortFields(remainingFields);
  const formErrors = useSelector((state) => getFormSyncErrors(props.formName)?.(state)) || {};
  const formMeta = useSelector((state) => getFormMeta(props.formName)?.(state));

  return (
    <>
      {topFields && (
        <PersonalFieldRelationshipContainer $isSingleRowField={props.isSingleRowField}>
          {Object.values(topFields).map((item) => {
            return renderFunc(item, props, null, formErrors, formMeta);
          })}
        </PersonalFieldRelationshipContainer>
      )}
      {(props?.userBankInfo?.displayBeneName || props.beneficiaryBankName) && (
        <BankNameContainer>
          <span className="bankingName">
            <p className="bankNameText">Banking name </p>
            <Popup
              className="bankNamePopup"
              hideOnScroll
              position="top center"
              trigger={<img alt="copy details" src={INFO_GREY_ICON} className="infoIcon" />}
              on="click"
              content={BANK_NAME_POPUP_CONTENT}
            />
            -
          </span>
          <p className="name">{` ${
            props?.userBankInfo?.beneficiaryBankName || props.beneficiaryBankName
          }`}</p>
        </BankNameContainer>
      )}

      <PersonalContainer $isSingleRowField={props.isSingleRowField}>
        {sortedFields.map((item, index) => {
          return (
            <GridColumn key={index}>
              {renderFunc(item, props, null, formErrors, formMeta)}
            </GridColumn>
          );
        })}
      </PersonalContainer>
    </>
  );
};

PersonalScreen.propTypes = {
  personal_fields: PropTypes.any,
  userBankInfo: PropTypes.object,
  isSingleRowField: PropTypes.bool,
  formName: PropTypes.string,
  dispatchAction: PropTypes.func,
  changeAction: PropTypes.func,
  formValues: PropTypes.object,
  selfPopulatingData: PropTypes.func,
  isPartiallyEditable: PropTypes.bool,
  isBeneAdditionFlow: PropTypes.bool,
  applyInFieldValidation: PropTypes.bool,
  setBeneCountryFieldDisabled: PropTypes.func,
  setBeneIdTypeFieldDisabled: PropTypes.func,
  beneficiaryBankName: PropTypes.string,
  isCountryOfResidenceDisabled: PropTypes.bool
};

export default PersonalScreen;
